// extracted by mini-css-extract-plugin
module.exports = {"creditContainer":"Credits-module_creditContainer_TLwk7","creditMessage":"Credits-module_creditMessage_3cLEp","creditLink":"Credits-module_creditLink_2kEUV"};